<template>
<div style="height: 100%;background-color:#fff;">
<div class="title">
    <strong @click="goIndex()" style="cursor: pointer;"><i class="el-icon-back"></i></strong>
    <span>创建提成方案</span>
</div>

<!-- 基本信息-->
<el-row>
    <el-col><div class="base-info"><span class="line" ></span> <span>基本信息</span></div></el-col>
</el-row>


<el-form 
:model="form" :rules="rules" :ref="form"  label-width="140px" class="demo-ruleForm">
    <el-form-item label="提成方案类型：" required  prop="planTypeDetail">
     <el-select v-model="form.planTypeDetail" placeholder="请选择提成方案" >
      <el-option label="订单实付金额提成" value="ddsfjetc"></el-option>
      <el-option label="订单收入提成" value="ddsrtc"></el-option>
    </el-select>
    </el-form-item>
      <el-form-item label="方案名称：" required prop="planName">
     <el-input placeholder="请选择方案名称" v-model="form.planName"></el-input>
  </el-form-item>
  <el-form-item label="提成类型：" >
    <el-col class="text-simple">消费提成</el-col>
      </el-form-item>
    <el-form-item label="适用门店：" >
        <el-col class="text-simple" >{{form.merchantName}}</el-col>
  </el-form-item>
  <el-form-item label="方案有效期：">
    <el-radio v-model="form.effectiveType" label="1">永久有效</el-radio>
  <el-radio v-model="form.effectiveType" label="0">自定义时间</el-radio>
  </el-form-item>
  <el-form-item v-if="form.effectiveType==0" label="自定义日期日：">
    <el-date-picker
    value-format="yyyy-MM-dd"
      v-model="dateRange"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>
</el-form>
<!-- 提成信息 -->
<el-row>
    <el-col><div class="base-info"><span class="line"></span> <span >提成信息</span></div></el-col>
</el-row>
<el-form :model="form"   ref="form" label-width="140px" :rules="rules" > 
    <el-form-item label="桌台区域：">
          <el-select 
          @change="selectedChanged"
          collapse-tags
          v-model="form.tableAreaName" placeholder="全部" multiple value-key="tableAreaCode" clearable>
          <el-option key="true" label="全部" value="selectAll"></el-option>
      <el-option :label="item.tableAreaName" :value="{tableAreaCode:item.tableAreaCode,tableAreaName:item.tableAreaName}" v-for="item,i in tableArarList" :key="i"></el-option>
    </el-select>
    </el-form-item>
    <el-form-item label="提成计算方式：">
      <el-radio v-model="form.calculateType" label="qjje">区间金额</el-radio>
  <el-radio v-model="form.calculateType" label="qjbl">区间比例</el-radio>
    </el-form-item>
    <el-form-item label="每笔订单实付金额" required >
      <div class="input-flex" v-for="item,i in form.rateList1" :key="i" v-if="form.calculateType=='qjje'">
        <el-input placeholder="" v-model="item.minCriticalAmount">
        <template slot="prepend">满</template>
    <template slot="append">元</template>
  </el-input>
        <el-input placeholder="" v-model="item.royaltyAmount">
        <template slot="prepend">提成</template>
    <template slot="append">元</template>
  </el-input>
  <el-button v-if="form.rateList1.length!=1" class="delete-button" @click.prevent="deleteInput(i)"> 删除</el-button>
      </div>
      <!-- 区间比例 -->
            <div class="input-flex" v-for="item,i in form.rateList2" :key="i" v-if="form.calculateType=='qjbl'">
        <el-input placeholder="" v-model="item.minCriticalAmount">
        <template slot="prepend">满</template>
    <template slot="append">元</template>
  </el-input>
        <el-input placeholder="" v-model="item.royaltyRate ">
        <template slot="prepend">提成</template>
    <template slot="append">%</template>
  </el-input>
    <el-button v-if="form.rateList2.length>1" class="delete-button" @click.prevent="deleteInput2(i)"> 删除</el-button>
      </div>
    </el-form-item>
    <el-form-item label=" ">
      <el-col v-if="form.calculateType=='qjje'" class="text-simple" style="font-size:14px;color:orange;cursor: pointer;" @click.native="addInput">添加</el-col>
      <el-col v-if="form.calculateType=='qjbl'" class="text-simple" style="font-size:14px;color:orange;cursor: pointer;" @click.native="addInput2">添加</el-col>
    </el-form-item>
</el-form>
<div class="foot-line"></div>
<div class="foot">
       <el-button @click="$router.push('/commission')">取消</el-button>
    <el-button type="primary" @click="submitForm(form)">保存并创建</el-button>
</div>
</div>
</template>

<script>
 export default {
    data() {
      return {
        tableArarList:[], //桌台区域下拉
        //
        form:{
          merchantCode:"",
          merchantName:'',
          planType:'ddtc',//单前订单提成
          commissionType:'xftc',
          planTypeDetail: 'ddsfjetc', //提成方案类型
          planName:'',//方案名称
          effectiveType:"1",//方案有效期
          startDate:"",
          endDate:'',
          calculateType:'qjje',//提成计算方式
          rateList1:[{minCriticalAmount:'',royaltyAmount:''}],
          rateList2:[{minCriticalAmount:'',royaltyRate:''}],
          tableAreaName:[]
        },
        //
        input2:'',
        commissionType:"1", //提成计算方式
        radio1:'', //方案有效期
        dishType:'',
        dialogVisible:false,
        input:'',
        tableData:[], 
        checked:'',
        dateRange:[],// 自定义时间范围
        radio2:'',
        radio3:"",
    //
        rules: {
          planName: [
            { required: true, message: '请输入方案名称', trigger: ['change','blur'] },
          ],
        }
      };
    },
    methods: {
      // 桌台区域下拉框
      getTableArea(){
        this.$http.post('/merchantAreaClasses/queryList',{merchantCode:this.form.merchantCode}).then(res=>{
          this.tableArarList=res.data.data.merchantAreaClassList
          // this.tableArarList.unshift({tableAreaName:'全部',tableAreaCode:''})
        })
      },
      deleteInput(index){
        if(this.form.rateList1.length==1)
        return
        this.form.rateList1.splice(index,1)
      },
        deleteInput2(index){
        if(this.form.rateList2.length==1)
        return
        this.form.rateList2.splice(index,1)
      },
      //提交
      submitForm(formName) {
        console.log(formName)
        this.$refs[formName].validate((valid) => {
          if (valid) {
          // 需要传中文名称
        if(this.form.planTypeDetail=='ddsfjetc'){
          this.form.planDetailName='订单实付金额提成'
        }else{
          this.form.planDetailName='订单收入提成'
        }
            if(this.form.tableAreaName.indexOf('selectAll')>-1 || this.form.tableAreaName.length==0|| this.form.tableAreaName==null){
              var arr=[]
              this.tableArarList.forEach(item=>{
                arr.push({tableAreaName:item.tableAreaName,tableAreaCode:item.tableAreaCode})
              })
              this.form.tableAreaName=arr
            }
            // 计算提成方式
            if(this.form.calculateType=='qjje'){
              this.form.calculateTypeName='区间金额'
              this.form.rateList=this.form.rateList1
               delete this.form.rateList1
                delete this.form.rateList2
            }else{
               this.form.calculateTypeName='区间比例'
              this.form.rateList=this.form.rateList2
               delete this.form.rateList1
              delete this.form.rateList2
            }
            // 有效时间
            if(this.form.effectiveType=='0'){
              this.form.startDate=this.dateRange[0]
              this.form.endDate=this.dateRange[1]
            }
            
            this.form.areaClassList=this.form.tableAreaName
            delete this.form.tableAreaName
            console.log(this.form)
         this.$http.post('/merchantEmployeeRoyaltyPlan/add',this.form).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.$message({
              type:"success",
              message:'保存成功'
            })
            this.$router.push('/commission?index=2')
          }else{
            this.$message.error(res.data.message)
          }
         })
          } else {
            this.$message.error('信息填写不正确')
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      //添加
      addInput(){
        console.log(11)
        this.form.rateList1.push({minCriticalAmount:"",royaltyAmount:''})
      },
        addInput2(){
          console.log(2)
        this.form.rateList2.push({minCriticalAmount:"",royaltyRate:''})
      },
      selectedChanged(v){
        console.log(v,'选中项',v.length,v.indexOf('selectAll'))
        // 全选存在
        if(v.indexOf('selectAll')>-1 && v.length>1 ){
          console.log('选了多个')
          this.form.tableAreaName=v.filter(item=>item!='selectAll')
        }
        if(v.indexOf('selectAll')>-1 && v.length>1 && v.indexOf('selectAll') !=0){
          this.form.tableAreaName=v.filter(item=>item=='selectAll')
        }
      },
      goIndex(){
        this.$confirm('确定退出编辑吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(this.$route.query.code){
            this.$router.push('/commission?index=2')
          }else{
            this.$router.push('/commission')
          }
        }).catch(() => {
          console.log('')       
        });
      },
      editData(){
            this.$http.post('/merchantEmployeeRoyaltyPlan/queryOne',{planType:this.$route.query.type,planCode:this.$route.query.code}).then(res=>{
          console.log(res,'数据回显')
          this.form=res.data.data
          if(res.data.data.calculateType=='qjje'){
            this.form.rateList1=this.form.rateList
          }else{
            this.form.rateList2=this.form.rateList
          }
          // 
          this.form.tableAreaName=this.form.areaClassList
          // 方案有效期
          if(res.data.data.effectiveType==0){
            this.dateRange[0]=res.data.data.startDate
            this.dateRange[1]=res.data.data.endDate
          }
          // 不予赠菜
          if(res.data.data.freeDishFlag==1){
            this.form.freeDishFlag=true
          }else{
            this.form.freeDishFlag=false
          }
          console.log(this.form.freeDishFlag,'赠菜')
          //售卖价
          
        
        })
      }
    },
    created () {
      this.form.merchantName=localStorage.getItem('merchantName')
      this.form.merchantCode=localStorage.getItem('merchantCode')
      this.getTableArea()
             if(this.$route.query.type && this.$route.query.code){
       this.editData()
       }
    }
  }
</script>

<style  lang="less" scoped>
.delete-button{
  margin-left: 20px;
  border: none;
  color: #f59a23;
}
.delete-button:hover{
  color: #f59a23;
  background-color: #fff;
}
.input-flex{
  display: flex;
  margin-bottom: 18px;
}
.foot-line{
  width: 100%;
  border-bottom: 2px solid #f6f6f6;
  margin-bottom: 20px;
}
.title{
    padding: 6px 10px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span{
        margin-left: 10px;
    }
    i,span{
      font-size: 20px;
    font-weight: 500;
    }
}
    .line {
        display: inline-block;
        width: 3px;
        height: 15px;
        background-color: orange;
        margin-right: 5px;
        border-radius: 2px;
        margin-bottom: -2px;
    }
    .base-info{
        margin: 30px 0px 10px 20px;
    }
.foot{
    display: flex;
    justify-content: right;
    height: 100px;
    background-color: #fff;
    padding-right: 60px;
}
    /deep/ .el-form {
        margin:10px 0 10px 38px;
    }
    /deep/ .el-form-item__content{
        margin-left: 5px !important;
    }
    /deep/ .el-input__inner{
        width: 220px;
    }
/deep/ .el-form-item{
    display: flex;
}
/deep/ .text-simple{
    color: #606266;
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #606266;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: #f59a23;
  background-color: #f59a23;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #606266;
}
/deep/ .el-input-group--append .el-input__inner{
  width: 70px;
}
/deep/ .el-input-group__append{
  padding: 0 10px;
}
/deep/ .el-input-group__prepend{
  background-color: #fff;
  border: none;
  padding: 0 4px;
}
/deep/ .input-flex .el-form-item__content{
  display: flex;
}
/deep/ .input-flex .el-form-item__content .el-input-group{
  margin-right: 18px;
}
/deep/ .input-flex div:nth-child(1){
  margin-right: 8px;
}
</style>